<template>
  <div class="study-box">
    <div class="bg-img">
      <div class="title-bar">
        <i class="icon-back" @click="goBack"></i>
        <h3 class="txt">学习进度</h3>
      </div>
    </div>
    <div class="progress-box">
      <div class="progress">
        <h3 class="tit">当前学习进度</h3>
        <div class="bar">
          <mt-progress :value="(list.studyDays / list.totalDays) * 100" :bar-height="8" v-show="isProShow">
            <div slot="start" class="start" ref="start">
              {{ list.studyDays }}天
            </div>
            <div slot="end" class="end">{{ list.totalDays }}天</div>
          </mt-progress>
        </div>
      </div>
    </div>

    <div class="time">
      统计截止时间：{{ list.endTime | formatDate("yyyy年MM月dd日") }}
    </div>
    <div
      class="btn-back"
      :class="list.studyDays < list.totalDays ? 'gray' : ''"
      @click="goToRefund()"
      v-show="!isShowProgress"
    >
      申请返学费
    </div>
    <div v-show="isShowProgress" class="btn-progress" @click="goToProgress()">查看退费进度</div>
    <div class="desc-tit">待学习内容</div>
    <span class="desc-sub">（完成任意一项即可）</span>
    <ul class="con-box">
      <li>
        <img
          class="img-url"
          src="../../assets/images/parent-card/icon-shipin2.png"
        />
        <div class="desc">
          <h3 class="tit">完成一堂趣味轻课</h3>
          <span class="type">视频</span>
          <span class="type">练习</span>
          <span class="time">预计11分钟</span>
        </div>
        <span class="status" v-if="list.studyStatus.lightCourse > 0">
          已完成
        </span>
        <span class="go-status" @click="handerDoTask(1)" v-else>
          去完成
        </span>
      </li>
      <li>
        <img
          class="img-url"
          src="../../assets/images/parent-card/icon-yinpin2.png"
        />
        <div class="desc">
          <h3 class="tit">收听一首科普音频</h3>
          <span class="type">音频</span>
          <span class="time">预计5分钟</span>
        </div>
        <span class="status" v-if="list.studyStatus.listen > 0">
          已完成
        </span>
        <span class="go-status" @click="handerDoTask(2)" v-else>
          去完成
        </span>
      </li>
      <li>
        <img
          class="img-url"
          src="../../assets/images/parent-card/signin_icon_dowork.png"
        />
        <div class="desc">
          <h3 class="tit">完成一关同步练习</h3>
          <span class="type">练习</span>
          <span class="time">预计5分钟</span>
        </div>
        <span class="status" v-if="list.studyStatus.exercise > 0">
          已完成
        </span>
        <span class="go-status" @click="handerDoTask(3)" v-else>
          去完成
        </span>
      </li>
      <li>
        <img
          class="img-url"
          src="../../assets/images/parent-card/signin_icon_dowork.png"
        />
        <div class="desc">
          <h3 class="tit">阅读一本有声绘本</h3>
          <span class="type">练习</span>
          <span class="time">预计5分钟</span>
        </div>
        <span class="status" v-if="list.studyStatus.reading > 0">
          已完成
        </span>
        <span class="go-status" @click="handerDoTask(4)" v-else>
          去完成
        </span>
      </li>
    </ul>
    <div class="gap"></div>
    <div class="btn logistic" @click="goToLogistic">
      礼包物流 <span class="go-icon"></span>
    </div>
    <div class="btn question" @click="goToTip">
      常见问题 <span class="go-icon"></span>
    </div>
  </div>
</template>
<script>
import utils from "@/assets/js/utils";
import ajax from "@/api/cardAjax";
import { Progress } from 'mint-ui';
const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");
export default {
  name: "studyProgress",
  component: {
    Progress
  },
  data() {
    return {
      list: {
        studyDays: 0, // 已学天数
        totalDays: 0, // 总天数
        endTime: "", // 截止日期,时间戳
        studyStatus: {
          // 当天各科学习状态 1已完成 0未完成
          exercise: 0, // 同步练
          reading: 0, // 绘本
          listen: 0, // 布克听世界
          lightCourse: 0, // 轻课
        },
      },
      isShowProgress: false,
      isProShow: true
    };
  },
  created() {
    console.log(window.location.href,1)
  },
  mounted(){
    this.getData();
  },
  methods: {
    async getData() {
      let timestamp = Date.parse(new Date());
      let resp = await ajax.get("/pay/return-money/get-progress", {
        params: { token, version, source ,timestamp},
      });
      if (resp.config) resp = resp.data;
      if (resp.code == 99999) {
        this.list = resp.data;
        console.log(34, resp,this.list);
        this.$nextTick(() => {
          this.$refs.start.style.left =
            (this.list.studyDays / this.list.totalDays) * 100 + "%";
        });
        if (resp.data.status == 1 || resp.data.status == 2) {
          this.isShowProgress = false
        } else {
          this.isShowProgress = true
        }
      } else {
        this.$toast(resp.msg);
      }
    },
    goBack() {
      window.location = "hybird://method/exit";
    },
    goToLogistic() {
      let timestamp = Date.parse(new Date());
      this.$router.push(
        `/card/logistics?source=${source}&token=${token}&version=${version}&random=${timestamp}`
      );
    },
    goToTip() {
      this.$router.push(`/card/questionTip?hideTitleBar=true`);
    },
    handerDoTask(type) {
      switch (type) {
        case 1:
          window.location.href = "hybird://method/openLiteCourseList";
          break;
        case 2:
          window.location.href = "hybird://method/openBukeListeningHomePage";
          break;
        case 3:
          window.location.href =
            "hybird://method/openSyncMathSecondaryHomePage";
          break;
        case 4:
          window.location.href = "hybird://method/openDreamReadHomePage";
          break;
      }
    },
    // 申请退费
    goToRefund() {
      if (this.list.totalDays > this.list.studyDays) {
        this.$toast("请先完成打卡！");
        return;
      }
      this.$router.push({ path: '/card/refund', query: {
        token: token, version: version, source: source
      }});
    },
    // 查看进度
    goToProgress() {
      this.isProShow = false
      this.$router.push({ path: '/card/refundProgress', query: {
        token: token, version: version, source: source
      }})
    }
  },
};
</script>
<style lang="scss" scoped>
.title-bar {
  margin: 0.3rem 0 0;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 0.34rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
}
.icon-back {
  width: 0.2rem;
  height: 0.35rem;
  background: url("../../assets/images/parent-card/nav_white.png");
  background-size: 100% 100%;
  float: left;
  margin: 0.05rem 0.3rem 0;
}
.bar {
  margin: 0 0.4rem 0 0.4rem;
  border-radius: 0.12rem;
  ::v-deep .mt-progress-runway {
    border-radius: 0.12rem;
    &:after {
      content: "";
      position: absolute;
      width: 0.48rem;
      height: 0.48rem;
      background: url("../../assets/images/parent-card/icon-notFinish.png");
      background-size: 100% 100%;
      right: 0rem;
      top: -0.15rem;
    }
  }
  ::v-deep .mt-progress {
    //position: relative;
    .end,
    .start {
      font-family: "BebasNeueBold";
      font-weight: 700;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.4rem;
      letter-spacing: 0rem;
      position: absolute;
      bottom: -0.38rem;
    }
    .end,
    .start {
      color: #919294;

      right: 0rem;
    }
    .start {
      color: #ff571d;
      left: 0.48rem;
    }
  }
  ::v-deep .mt-progress-progress {
    position: absolute;
    background-color: #febe3d;
    border-radius: 0.2rem 0 0 0.2rem;
    &:after {
      content: "";
      position: absolute;
      width: 0.48rem;
      height: 0.48rem;
      background: url("../../assets/images/parent-card/icon-finish.png");
      background-size: 100% 100%;
      right: -0.46rem;
      top: -0.15rem;
    }
  }
}
.go-icon {
  display: inline-block;
  width: 0.09rem;
  height: 0.16rem;
  background-color: #919294;
  background: url("../../assets/images/parent-card/icon-arrow.png");
  background-size: 100% 100%;
}
.gap {
  width: 7.5rem;
  height: 0.2rem;
  background-color: #f6f6f8;
  margin-left: -0.3rem;
}
.go-status {
  width: 1.4rem;
  height: 0.56rem;
  background-color: #43a5f3;
  border-radius: 0.28rem;
  font-family: PingFangSC-Regular;
  font-size: 0.26rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  font-family: PingFangSC-Medium;
  font-size: 0.28rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #161616;
  background: #fff;
  height: 1.2rem;
  margin: 0 0.32rem;
  line-height: 1.2rem;
  border-bottom: 0.03rem solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-box {
  width: 6.9rem;
  //height: 5.83rem;
  background-color: #ffffff;
  box-shadow: 0rem 0.04rem 0.28rem 0rem rgba(0, 0, 0, 0.05);
  border-radius: 0.14rem;
  border: solid 0.01rem #f0f0f0;
  padding: 0.3rem;
  margin: 0 0 0.66rem;
  .status {
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #43a5f3;
    width: 1.4rem;
    text-align: center;
  }
  li {
    display: flex;
    align-items: center;
    height: 1.4rem;
    .desc {
      flex: 1;
      // align-items: center;
      // display: flex;
    }
    .tit {
      font-family: PingFangSC-Medium;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #161616;

      height: 0.32rem;

      border-radius: 0.06rem;
      margin: 0 0 0.13rem;
    }
    .type {
      font-family: PingFangSC-Regular;
      font-size: 0.22rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.22rem;
      letter-spacing: 0rem;
      color: #5f6162;
      background-color: #f6f6f8;
      margin: 0 0.1rem 0 0;
      width: 0.6rem;
    }
    .time {
      height: 0.33rem;
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #bec0c2;
    }
  }
  .img-url {
    width: 1rem;
    height: 1rem;
    // background-color: #000000;
    border-radius: 0.5rem;
    // opacity: 0.3;
    margin: 0 0.2rem 0 0;
  }
}
.study-box {
  background: #fff;
  position: relative;
  padding: 0 0.3rem;
  .bg-img {
    width: 7.5rem;
    height: 3.1rem;
    position: absolute;
    top: 0;
    left: 0;
    background: url("../../assets/images/parent-card/icon-big-bg.png");
    background-size: 100% 100%;
    z-index: 1;
  }
}
.time {
  width: 3.79rem;
  height: 0.3rem;
  font-family: PingFangSC-Regular;
  font-size: 0.22rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #919294;
  margin: 0.16rem 0 0.5rem;
}
.btn-back {
  width: 6.7rem;
  height: 0.88rem;
  line-height: 0.88rem;
  background-color: #ff571d;
  border-radius: 0.44rem;

  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: center;
  margin: 0 0 0.58rem;
}
.btn-progress {
   width: 6.7rem;
  height: 0.88rem;
  line-height: 0.88rem;
  background-color: #ff571d;
  border-radius: 0.44rem;

  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: center;
  margin: 0 0 0.58rem;
}
.gray {
  background: #b0b0b0;
}
.desc-tit {
  width: 100%;
  text-align: center;
  height: 0.48rem;
  font-family: PingFangSC-Semibold;
  font-size: 0.34rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #43a5f3;
}

.desc-sub {
  height: 0.33rem;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #919294;
  width: 100%;
  text-align: center;
  display: block;
  margin: 0.1rem 0 0.3rem;
}
.progress-box {
  overflow: hidden;
}
.progress {
  width: 6.9rem;
  height: 2.09rem;
  background-color: #ffffff;
  box-shadow: 0rem 0.04rem 0.28rem 0rem rgba(0, 0, 0, 0.1);
  border-radius: 0.14rem;
  border: solid 0.01rem #f0f0f0;
  position: relative;
  //top:2.36rem;
  margin: 2.36rem auto 0;
  z-index: 2;
  .tit {
    width: 100%;
    height: 0.4rem;
    font-family: PingFangSC-Medium;
    font-size: 0.28rem;
    font-weight: 700;
    font-stretch: normal;
    line-height: 0.4rem;
    letter-spacing: 0rem;
    color: #5f6162;
    text-align: center;
    margin: 0.33rem auto 0.18rem;
  }
}
</style>
